var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 64C326.4 64 179.2 211.2 179.2 396.8c0 64 19.2 115.2 44.8 166.4 0 6.4 256 384 256 384C486.4 953.6 499.2 960 512 960c12.8 0 25.6-6.4 32-12.8 0 0 256-377.6 256-377.6 32-51.2 51.2-108.8 51.2-172.8C851.2 211.2 697.6 64 512 64zM736 537.6 736 537.6C736 544 736 544 736 537.6L627.2 704c0 0 0 0 0 0L512 870.4 396.8 704c0 0 0 0 0 0L288 544l0 0C262.4 499.2 243.2 448 243.2 396.8 243.2 249.6 364.8 128 512 128s268.8 115.2 268.8 262.4C780.8 448 761.6 499.2 736 537.6L736 537.6zM512 262.4C435.2 262.4 377.6 320 377.6 396.8S435.2 524.8 512 524.8s134.4-57.6 134.4-134.4S588.8 262.4 512 262.4zM512 460.8c-38.4 0-70.4-32-70.4-64s32-64 70.4-64 70.4 32 70.4 64S550.4 460.8 512 460.8z",
    fill: "#A594B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.dba604d622e7d2296372d5f474ed8e5a.svg";
export { ForwardRef as ReactComponent };